import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GuestLayoutComponent } from './guest-layout.component';
import { TranslocoModule } from '@ngneat/transloco';
import { RouterModule } from '@angular/router';
import { LanguageSwitchModule } from 'app/common/components/language-switch/language-switch.module';


@NgModule({
  declarations: [
    GuestLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    LanguageSwitchModule
  ],
  exports: [
    // RouterModule,
    GuestLayoutComponent
  ]
})
export class GuestLayoutModule { }
